import React from 'react';
import ReactDOM from 'react-dom';
import styled from 'styled-components';

const Layout = styled.div``;

const AnchorLayout = styled.div``;

interface AnchorProps {
  name: string;
  className?: string;
  style?: React.CSSProperties;
}

class Anchor extends React.Component<AnchorProps, any> {
  public render() {
    const { name, className, style } = this.props;
    return (
      <AnchorLayout data-anchor={name} className={className} style={style}>
        {this.props.children}
      </AnchorLayout>
    );
  }
}

interface ScrollerProps {
  style?: React.CSSProperties;
  className?: string;
}

export class Scroller extends React.Component<ScrollerProps, any> {
  public static Anchor = Anchor;
  public anchors: any = {};
  public layout: HTMLDivElement;
  public chs: {
    [key: string]: any
  } = {};

  public scrollTo(anchor: string) {
    React.Children.forEach(this.props.children, (child: any) => {
      if (child.type === Anchor) {
        const { name } = child.props;
        if (name === anchor) {
          const thisEle = ReactDOM.findDOMNode(this) as HTMLElement;
          const target = thisEle.querySelector(`*[data-anchor=${anchor}]`);
          if (target) {
            target.scrollIntoView();
          }
        }
      }
    });
  }

  public render() {
    const { style, className } = this.props;
    return (
      <Layout ref={v => (this.layout = v)} style={style} className={className}>
        {this.props.children}
      </Layout>
    );
  }
}
